import React from 'react';
import { motion } from 'framer-motion';
import '../styles/ComparisonBlock.css';

const ComparisonBlock = () => {
  const items = [
    {
      before: 'Dudas en cada entrada',
      after: 'Entender qué hace un operador profesional y qué no',
    },
    {
      before: 'Estrategias que sirven solo en backtest',
      after: 'Ver cómo se ejecuta una estrategia real en vivo',
    },
    {
      before: 'Brokers manipulándote sin que lo sepas',
      after: 'Saber cuándo operar y cuándo NO',
    },
    {
      before: 'Sin plan, sin estructura, sin proceso',
      after: 'Tener un proceso mecánico (no emocional)',
    },
    {
      before: 'Siguiendo señales de otros',
      after: 'Detectar liquidez y errores del retail',
    },
    {
      before: 'Años perdidos sin ver resultados',
      after: 'Tener claridad para decidir si el trading es para ti',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <motion.div
      className="comparison-grid"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="comparison-column">
        <h3 className="column-title before-title">ANTES ❌</h3>
        <motion.div className="items-list">
          {items.map((item, index) => (
            <motion.div key={index} className="comparison-item before" variants={itemVariants}>
              <span className="item-icon">❌</span>
              <span className="item-text">{item.before}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <div className="comparison-divider">
        <div className="arrow">→</div>
      </div>

      <div className="comparison-column">
        <h3 className="column-title after-title">DESPUÉS ✅</h3>
        <motion.div className="items-list">
          {items.map((item, index) => (
            <motion.div key={index} className="comparison-item after" variants={itemVariants}>
              <span className="item-icon">✅</span>
              <span className="item-text">{item.after}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <div className="comparison-note">
        <p className="note-text">En 7 días no te vuelves rico.</p>
        <p className="note-text highlight">En 7 días dejas de estar perdido.</p>
      </div>
    </motion.div>
  );
};

export default ComparisonBlock;
